import { LocalStorageService } from '@/core/services/localStorageService';

const AUTONOMOUS_PRODUCT_PRICES_KEY = 'autonomousProductsPrices';

export const AutonomousProductsService = () => {

    const getPrices = () => {
        return LocalStorageService.get(AUTONOMOUS_PRODUCT_PRICES_KEY) ?? {}
    }
    
    const storePrices = (autonomousProductsPrices) => {
        LocalStorageService.set(AUTONOMOUS_PRODUCT_PRICES_KEY, autonomousProductsPrices)
    }

    return {
        getPrices,
        storePrices,
    }
}
